import { Helmet } from "react-helmet-async"
import { Briefcase, Users, GraduationCap, Heart, ChevronDown, MapPin } from "lucide-react"
import { Link } from "react-router-dom"
import { useState, useEffect } from "react"
import { Button } from "../../components/ui/button"
 
const WP_API_BASE = "/wp-json/wp/v2"
 
export default function Careers() {
  const [openings, setOpenings] = useState([])
  const [visibleCount, setVisibleCount] = useState(6)
  const [loading, setLoading] = useState(true)
 
  useEffect(() => {
    const fetchCareers = async () => {
      try {
        const res = await fetch(`${WP_API_BASE}/careers?per_page=100&acf_format=standard`)
        const data = await res.json()
        const mapped = data.map(job => ({
          slug: job.slug,
          title: job.title.rendered,
          description: job.acf?.short_description || "",
          location: job.acf?.job_location || "Hyderabad"
        }))
        setOpenings(mapped)
      } catch (err) {
        console.error("Error fetching careers:", err)
      } finally {
        setLoading(false)
      }
    }
    fetchCareers()
  }, [])
 
  const handleLoadMore = () => {
    setVisibleCount(prev => prev + 6)
  }
 
  return (
    <>
      <Helmet>
        <title>Careers - Pranaam Hospitals</title>
      </Helmet>
     
      <div className="min-h-screen bg-gray-50">
        {/* Hero Section */}
     
 
        <div className="container mx-auto px-4 py-8 md:py-16">
          <div className="max-w-6xl mx-auto">
            {/* Introduction Section */}
            <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
              <div className="order-2 lg:order-1">
                <h1 className="text-2xl md:text-4xl font-bold text-[#A32725] mb-6">THE PRESCRIPTION FOR A HEALTHY CAREER!</h1>
                <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6">
                  Pranaam throws open the doors to opportunity for talented professionals. You can expect a conducive work environment, a high degree of professionalism, enlightened HR policies and a career graph that shows a healthy upward trend.
                </p>
                <p className="text-xl font-bold text-black italic">
                  Come, your future awaits you at Pranaam!
                </p>
              </div>
              <div className="order-1 lg:order-2 rounded-2xl overflow-hidden shadow-xl h-64 md:h-96">
                <img src="/images/ModernHospitalFacility.png" alt="Pranaam Career" className="w-full h-full object-cover" />
              </div>
            </div>
 
            <div className="bg-white rounded-xl shadow-lg p-6 md:p-12 mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-10 border-b pb-4 border-black/10">Current Openings</h2>
              <div className="flex flex-col gap-8">
                {loading ? (
                  <div className="text-center py-10">
                    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#A32725] mx-auto"></div>
                    <p className="mt-4 text-gray-500">Loading current openings...</p>
                  </div>
                ) : (
                openings.slice(0, visibleCount).map((job, index) => (
                  <div key={index} className="border-b border-gray-100 last:border-0 pb-8 last:pb-0 group">
                    <div className="flex flex-col md:flex-row md:items-start justify-between gap-6">
                      <div className="flex-1 space-y-4">
                        <h3 className="text-xl md:text-2xl font-bold text-gray-900 group-hover:text-[#A32725] transition-colors">{job.title}</h3>
                        <div className="flex items-center gap-2 text-[#A32725] font-semibold">
                          <MapPin className="w-5 h-5" />
                          {job.location}
                        </div>
                        <p className="text-gray-600 text-lg leading-relaxed">{job.description}</p>
                      </div>
                      <Link
                        to={`/careers/${job.slug}`}
                        className="md:mt-2 bg-[#A32725] text-white px-8 py-3 rounded-lg hover:bg-[#8e1f1d] transition-all text-center font-bold whitespace-nowrap shadow-md hover:shadow-lg flex-shrink-0"
                      >
                        More Details & Apply
                      </Link>
                    </div>
                  </div>
                ))
                )}
                {!loading && openings.length === 0 && (
                  <p className="text-center text-gray-500 py-10">
                    No current openings at the moment. Please check back later.
                  </p>
                )}
              </div>
 
              {visibleCount < openings.length && (
                <div className="text-center mt-10">
                  <Button onClick={handleLoadMore} size="lg" className="bg-black hover:bg-gray-800 text-white gap-2 transition-colors">
                    <ChevronDown className="w-5 h-5" />
                    Load More Jobs
                  </Button>
                </div>
              )}
            </div>
 
           
          </div>
        </div>
      </div>
    </>
  )
}